// Runs each name in data-behavior="a b" once per element.
export function startBehaviors(registry) {
  const run = () => initBehaviors(registry)
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", run) : run()
}

// For markup inserted later, e.g. after a fetch.
export function initBehaviors(registry, scope = document) {
  scope.querySelectorAll("[data-behavior]").forEach((el) => {
    const started = new Set((el.dataset.behaviorsStarted || "").split(" ").filter(Boolean))

    el.dataset.behavior.split(" ").filter(Boolean).forEach((name) => {
      if (started.has(name)) return
      const behavior = registry[name]
      if (!behavior) return console.warn(`Unknown behavior "${name}"`, el)
      behavior(el)
      started.add(name)
    })

    el.dataset.behaviorsStarted = [...started].join(" ")
  })
}
